function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import extractPropertyFromState from './extractPropertyFromState';
import hasErrors from './hasErrors';
import React, { Component } from 'react';
import RPT from 'prop-types';
import validateField from './validateField';
import _isDirtyForm from './isDirtyForm';
import { clearFormProperty, setMultipleFields, setFieldValue, clearForm, setFormFieldError } from './actions';

var Form = /*#__PURE__*/function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Form)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "fields", {});

    return _this;
  }

  _createClass(Form, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        onionFieldRegister: this.fieldRegister.bind(this),
        onionFormName: this.props.name,
        onionLiveValidate: this.liveValidate.bind(this),
        onionValidateField: this.onionValidateField.bind(this),
        onionFormIsDirty: this.isDirtyForm.bind(this),
        onionOnSubmit: this.onSubmit.bind(this)
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props = this.props,
          resetOnMount = _this$props.resetOnMount,
          resetOnUnmount = _this$props.resetOnUnmount,
          name = _this$props.name;
      var dispatch = this.context.store.dispatch;

      if (resetOnMount || resetOnUnmount) {
        if (resetOnMount) console.warn('On `Form` instead of `resetOnMount` use `resetOnUnmount` property'); // eslint-disable-line no-console

        dispatch(clearForm(name));
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      event.preventDefault();
      return this.submit();
    }
  }, {
    key: "onionValidateField",
    value: function onionValidateField(fieldName) {
      var name = this.props.name;
      var dispatch = this.context.store.dispatch;

      var values = this._getValues();

      var errors = this._getErrors();

      var liveValidations = this._getProperties('liveValidation');

      var liveValidationEnabled = liveValidations[fieldName];
      var currentError = errors[fieldName];
      var error = validateField(values[fieldName], this._extractValidationsFromField(fieldName), values);

      if (liveValidationEnabled && error !== currentError) {
        dispatch(setFormFieldError(name, fieldName, error));
      }
    }
  }, {
    key: "liveValidate",
    value: function liveValidate() {
      var name = this.props.name;
      var getState = this.context.store.getState;
      var liveValidationsEnabled = extractPropertyFromState(getState(), name, 'liveValidation');
      var fieldsToValidate = Object.keys(this.fields).filter(function (fieldName) {
        return liveValidationsEnabled[fieldName];
      });
      return this.validate(fieldsToValidate);
    }
  }, {
    key: "fieldRegister",
    value: function fieldRegister(fieldName, field, value) {
      var name = this.props.name;

      if (field) {
        this.fields[fieldName] = field;

        this._setInitialFieldValue(name, fieldName, value);
      } else {
        delete this.fields[fieldName];
      }
    }
  }, {
    key: "formValidate",
    value: function formValidate() {
      var _this2 = this;

      this._enableAllFieldsLiveValidation();

      this._allFieldNames().forEach(function (fieldName) {
        return _this2.onionValidateField(fieldName);
      });

      return this.validate(this._allFieldNames());
    }
  }, {
    key: "validate",
    value: function validate(fieldsToValidate) {
      var name = this.props.name;
      var dispatch = this.context.store.dispatch;
      return dispatch(setMultipleFields(name, 'error', this._getValidationErrors(fieldsToValidate)));
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          onError = _this$props2.onError,
          onSubmit = _this$props2.onSubmit;

      var values = this._getValues();

      var errors = this._getErrors(); // check for validation errors


      if (!this._isValid()) {
        if (typeof onError === 'function') onError({
          name: name,
          errors: errors
        });
        return false;
      }

      if (typeof onSubmit === 'function') onSubmit({
        name: name,
        values: values
      });
      return true;
    }
  }, {
    key: "isDirtyForm",
    value: function isDirtyForm() {
      var customCheckDirtyFunction = this.props.customCheckDirtyFunction;
      return customCheckDirtyFunction ? customCheckDirtyFunction(this._getValues()) : _isDirtyForm(this._getValues());
    }
  }, {
    key: "_setInitialFieldValue",
    value: function _setInitialFieldValue(name, fieldName, value) {
      var dispatch = this.context.store.dispatch;
      var isUndefined = value === undefined;
      var isNull = value === null;
      var isNil = isUndefined || isNull;

      if (!isNil) {
        dispatch(setFieldValue(name, fieldName, value));
      }
    }
  }, {
    key: "_isValid",
    value: function _isValid() {
      var name = this.props.name;
      var dispatch = this.context.store.dispatch; // Cleanup all previous errors

      dispatch(clearFormProperty(name, 'error')); // Validate all fields

      this.formValidate();
      return !this._hasErrors();
    }
  }, {
    key: "_hasErrors",
    value: function _hasErrors() {
      var name = this.props.name;
      var getState = this.context.store.getState;
      return hasErrors(getState(), name);
    }
  }, {
    key: "_getProperties",
    value: function _getProperties(propertyName) {
      var name = this.props.name;
      var getState = this.context.store.getState;
      return extractPropertyFromState(getState(), name, propertyName);
    }
  }, {
    key: "_getErrors",
    value: function _getErrors() {
      return this._getProperties('error');
    }
  }, {
    key: "_getValues",
    value: function _getValues() {
      return this._getProperties('value');
    }
  }, {
    key: "_extractValidationsFromField",
    value: function _extractValidationsFromField(fieldName) {
      var field = this.fields[fieldName];
      var validations = this.props.validations;
      if (!field || typeof field.validations !== 'function' || !field.props) return validations[fieldName] || [];
      return (validations[fieldName] || []). // 1. validations from form level <Form validations={{'name': [isRequired()]}} />
      concat(field.validations() || []) // 2. add validations from createField level createField('name', {}, [isRequired()])
      .concat(field.props.validations || []); // 3. add validations from instance level <Field validations=[isRequired()] />
    }
  }, {
    key: "_getValidationErrors",
    value: function _getValidationErrors(fieldsToValidate) {
      var _this3 = this;

      var values = this._getValues();

      return fieldsToValidate.reduce(function (acc, fieldName) {
        return _objectSpread({}, acc, _defineProperty({}, fieldName, validateField(values[fieldName], _this3._extractValidationsFromField(fieldName), values)));
      }, {});
    }
  }, {
    key: "_enableAllFieldsLiveValidation",
    value: function _enableAllFieldsLiveValidation() {
      var name = this.props.name;
      var dispatch = this.context.store.dispatch;
      return dispatch(setMultipleFields(name, 'liveValidation', this._allFieldNames().reduce( // this will create { field1: true, field2: true, ...}
      function (acc, field) {
        return _objectSpread({}, acc, _defineProperty({}, field, true));
      }, {})));
    }
  }, {
    key: "_allFieldNames",
    value: function _allFieldNames() {
      var validations = this.props.validations;
      return Object.keys(this.fields).concat(Object.keys(validations));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          method = _this$props3.method;
      return React.createElement("form", {
        onSubmit: this.onSubmit.bind(this),
        method: method,
        noValidate: true
      }, children);
    }
  }]);

  return Form;
}(Component);

_defineProperty(Form, "propTypes", {
  children: RPT.oneOfType([RPT.node, RPT.string]).isRequired,
  method: RPT.string,
  name: RPT.string.isRequired,
  customCheckDirtyFunction: RPT.func,
  onError: RPT.func,
  onSubmit: RPT.func,
  validations: RPT.object,
  resetOnUnmount: RPT.bool,
  resetOnMount: RPT.bool
});

_defineProperty(Form, "contextTypes", {
  store: RPT.object.isRequired
});

_defineProperty(Form, "childContextTypes", {
  onionFieldRegister: RPT.func.isRequired,
  onionFormName: RPT.string.isRequired,
  onionLiveValidate: RPT.func.isRequired,
  onionValidateField: RPT.func.isRequired,
  onionFormIsDirty: RPT.func.isRequired,
  onionOnSubmit: RPT.func.isRequired
});

_defineProperty(Form, "defaultProps", {
  method: 'POST',
  validations: {}
});

export { Form as default };